import MicroModal from '../lib/micromodal';
export default class CitySelectorModal {
    constructor() {
        this.fired = false;
        this.initListeners();
    }

    initListeners() {
        const citySelectors = document.querySelectorAll('[data-js-selected-city]');
        if (citySelectors.length > 0) {
            citySelectors.forEach(citySelector => {
                citySelector.addEventListener('click', (e) => {
                    MicroModal.show('city-selector-modal', {
                        awaitOpenAnimation: true, // [8]
                        awaitCloseAnimation: true, // [9]
                        disableScroll: true,
                    });
                })
            })
        }

        const liveSearch = document.querySelector('[data-js-city-live-search]');
        if (liveSearch) {
            liveSearch.addEventListener('keyup', (e) => this.liverSearch(e.target));
            liveSearch.addEventListener('focus', async (e) => this.loadItems());
            document.addEventListener('mousedown', (e) => {
                if (e.target.classList.contains('city-selector-list__item')) {
                    window.location.href = e.target.dataset.href;
                }
                let items = document.querySelectorAll('[data-js-city-live-search-item]');
                items.forEach(box => { box.style.display = 'none' })
            });
        }
    }

    liverSearch(el) {
        let needle = el.value.trim();
        let items = document.querySelectorAll('[data-js-city-live-search-item]');
        items.forEach((item, i) => {
            item.style.display = 'none';
            let cityName = item.dataset.city;
            if (cityName.match(new RegExp(needle, 'i'))) {
                item.style.display = 'block';
            }
        })
    }

    clickCity(el) {
        if (!liveSearch.contains(el)) {
            if (!el.classList.contains('city-selector-list__item')) {
                let items = document.querySelectorAll('[data-js-city-live-search-item]');
                items.forEach(box => { box.style.display = 'none' })
            } else {
                window.location.href = el.dataset.href;
            }
        }
    }

    async loadItems() {
        if (!this.fired) {
            const ul = document.querySelector('.city-selector-list');
            let response = await fetch('/api/agglomerations');
            let list = await response.json();
            for (const [i, v] of Object.entries(list.selector)) {
                let li = document.createElement('li');
                li.className = 'city-selector-list__item';
                li.dataset.city = v;
                li.dataset.href = `/city/change/${i}/`;
                li.dataset.jsCityLiveSearchItem = null;

                let span = document.createElement('span');
                span.className = 'cl-style__link_underline-none';
                span.style.pointerEvents = 'none';
                span.textContent = v;
                li.append(span);
                ul.append(li)
            }
            this.fired = true;
        }
    }
}
